export default __webpack_public_path__ + "images/kaxaar_879658.svg";